import React from 'react';
import PopUp from '../modals/popup';
import SearchBox from '../search/field';

class SearchOverlay extends React.Component {

    constructor(props) {
        super(props);

        this.searchOpenBtn = document.querySelector('#searchOpenBtn');
        this.searchPopUp = React.createRef();
        this.searchBox = React.createRef();
    }

    componentDidMount() {
        if (this.searchOpenBtn) {
            this.searchOpenBtn.addEventListener('click', this.open, false);
        }
    }

    open = () => {
        this.searchPopUp.current.open();
    };

    render() {
        return (
            <React.Fragment>
                <PopUp ref={this.searchPopUp} afterOpen={() => { this.searchBox.current.setFocus(); } }
                       className='reveal--secondary reveal--full flex align-mc' disableOuterPageScroll={true}>
                    <div className="pad-20 text-width width-100p">
                        <div className="reveal__close" onClick={() => {this.searchPopUp.current.close()}} />
                        <SearchBox ref={this.searchBox} />
                    </div>
                </PopUp>
            </React.Fragment>
        );
    }
}

export default SearchOverlay;